export default __webpack_public_path__ + "static/licence-QLD-back-b6d429b2017dbe164106a0221ea5cb7c.svg";